<template>
  <b-modal id="modal-currency-mismatch" centered @shown="show" @ok="confirm" hide-header @hidden="hidden">
    <div class="d-block text-center">
      <Icon name="grAlertTriangle" width="36" class="mb-3"/>
      <h1 class="modal-title mb-3">{{$t('modal_currency_mismatch.title')}}</h1>
      <p>{{ $t('modal_currency_mismatch.text') }}</p>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="row w-100 justify-content-center">
        <div class="col-sm-6">
          <b-button variant="primary" block @click="cancel()">{{$t('modal_currency_mismatch.btn_ok')}}</b-button>
        </div>
      </div>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: 'ModalCurrencyMismatch',

  methods: {
    show() {
      this.$emit('shown')
    },

    confirm() {
      this.$emit('confirm')
    },

    hidden() {
      this.$emit('hidden')
    }
  }
}
</script>
